export default "__VITE_ASSET__DPk6eAeF__"